<template>
  <div class="div" v-loading="loading">
    <div class="div-center">
      <el-tabs
        v-model="activeName"
        type="card"
        style="height: 100%"
        @tab-click="tabClick"
      >
        <el-tab-pane label="设备成本分析" name="CostEcharts">
          <div class="div-top">
            <el-date-picker
              v-model="searchYear"
              type="year"
              value-format="yyyy"
              @change="getEchartsData"
              placeholder="选择年"
            >
            </el-date-picker>
          </div>
          <!-- 柱状图卡片（先显示） -->
          <el-card
            class="chart-card"
            header="各月设备总成本"
            style="margin-bottom: 16px"
          >
            <div class="tab-chart-container"></div>
          </el-card>
          <!-- 饼图卡片（后显示） -->
          <el-card class="chart-card" header="各月成本分布">
            <div class="tab-chart-pieList">
              <div class="pie-charts-container">
                <div
                  v-for="(month, index) in monthChartData"
                  :key="month.name"
                  :id="`pie-chart-${index}`"
                  class="pie-chart-item"
                ></div>
              </div>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane label="设备成本" name="Cost">
          <div class="div-top">
            <el-date-picker
              v-model="rDate"
              type="monthrange"
              range-separator="至"
              :clearable="false"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              value-format="yyyyMM"
            >
            </el-date-picker>
            <el-input
              v-model="searchData.Keyword"
              clearable
              placeholder="请输入设备名称/编码"
              style="width: 300px; margin-left: 10px"
            ></el-input>
            <el-button
              type="primary"
              @click="handleSearch"
              style="margin-left: 10px"
              >查询</el-button
            >
            <el-button
              type="warning"
              @click="handleExport"
              style="margin-left: 10px"
              icon="el-icon-download"
              >导出数据</el-button
            >
          </div>
          <el-table
            :data="tableData"
            ref="table"
            style="width: 100%"
            height="calc(100% - 90px)"
          >
            <el-table-column
              label="设备分类"
              align="center"
              prop="DeviceTypeName"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="设备编号"
              align="center"
              prop="DeviceCode"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="设备名称"
              align="center"
              prop="DeviceName"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="年月"
              align="center"
              prop="iYearMonth"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="安装位置"
              align="center"
              prop="Position"
              sortable
            >
            </el-table-column>
            <el-table-column label="能耗" align="center">
              <el-table-column
                label="电"
                align="right"
                prop="ElectricityAmount"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.ElectricityAmount, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="水"
                align="right"
                prop="WaterAmount"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.WaterAmount, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="气"
                align="right"
                prop="GasAmount"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.GasAmount, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="小计"
                align="right"
                prop="SubTotal"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.SubTotal, 2) }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="机物料摊销"
              align="right"
              prop="AmortizationAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.AmortizationAmount, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              label="外委维修"
              align="right"
              prop="OutsourcingAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.OutsourcingAmount, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              label="折旧"
              align="right"
              prop="DeviceDepreciationAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.DeviceDepreciationAmount, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              label="成本总计"
              align="right"
              prop="ToTalAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.ToTalAmount, 2) }}
              </template>
            </el-table-column>
          </el-table>
          <div
            style="
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: right;
            "
          >
            <el-pagination
              style="margin-top: 10px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.PageIndex"
              :page-sizes="pagination.PageSizes"
              :page-size="pagination.PageRows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import tools from '@/utils/tools.js'
import * as echarts from 'echarts'
export default {
  data() {
    return {
      tools,
      moment,
      searchData: {
        Keyword: '',
        isYearMonth: '',
        ieYearMonth: '',
      },
      rDate: [],
      tableData: [],
      totalData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
      activeName: 'CostEcharts',
      searchYear: '',
      chartData: [],
      monthChartData: [],
    }
  },
  props: {},
  components: {},
  methods: {
    tabClick(tab) {
      this.activeName = tab.name
      this.chartData = []
      if (this.activeName === 'CostEcharts') {
        this.getEchartsData()
      } else {
        this.getDataList()
      }
    },
    handleExport() {
      this.searchData.isYearMonth = this.rDate ? this.rDate[0] : ''
      this.searchData.ieYearMonth = this.rDate ? this.rDate[1] : ''
      if (this.searchData.isYearMonth && this.searchData.ieYearMonth) {
        tools.download(
          this.$rootUrl +
            `/Base_DeviceTreeManage/Device/ExportToExcel?DeviceType=${
              this.devTreeSearch.DeviceType || ''
            }&BuildingId=${
              this.devTreeSearch.BuildingId || ''
            }&InstallationArea=${
              this.devTreeSearch.InstallationArea || ''
            }&isYearMonth=${this.searchData.isYearMonth || ''}&ieYearMonth=${
              this.searchData.ieYearMonth || ''
            }&DeviceCode=${this.searchData.Keyword || ''}`,
          '设备成本分析',
          '.xlsx',
          'get'
        )
      } else {
        return this.$notify.warning('请选择年月后导出')
      }
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    fun(val) {
      return '折旧总金额：' + (Number(val) === 0 ? 0 : Number(val).toFixed(2))
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device/GetDeviceCostDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'Id',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'DeviceType',
              Keyword: this.devTreeSearch.DeviceType || '',
            },
            {
              Condition: 'BuildingId',
              Keyword: this.devTreeSearch.BuildingId || '',
            },
            {
              Condition: 'InstallationArea',
              Keyword: this.devTreeSearch.InstallationArea || '',
            },
            {
              Condition: 'isYearMonth',
              Keyword: this.searchData.isYearMonth || '',
            },
            {
              Condition: 'ieYearMonth',
              Keyword: this.searchData.ieYearMonth || '',
            },
            {
              Condition: 'DeviceCode',
              Keyword: this.searchData.Keyword || '',
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data || []
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.searchData.isYearMonth = this.rDate ? this.rDate[0] : ''
      this.searchData.ieYearMonth = this.rDate ? this.rDate[1] : ''
      if (this.searchData.isYearMonth && this.searchData.ieYearMonth) {
        this.pagination.PageIndex = 1
        this.getDataList()
      } else {
        return this.$notify.warning('请选择年月后查询')
      }
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    getEchartsData() {
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device/GetDeviceCostDataListAnalysis', {
          Search: [
            {
              Condition: 'DeviceType',
              Keyword: this.devTreeSearch.DeviceType || '',
            },
            {
              Condition: 'BuildingId',
              Keyword: this.devTreeSearch.BuildingId || '',
            },
            {
              Condition: 'InstallationArea',
              Keyword: this.devTreeSearch.InstallationArea || '',
            },
            {
              Condition: 'YearMonth',
              Keyword: this.searchYear,
            },
          ],
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.monthChartData = res.Data.monthlist || []
            this.chartData = res.Data.list || []
            this.$nextTick(() => {
              this.renderEcharts()
              this.renderPieCharts()
            })
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    renderEcharts() {
      const dom = document.querySelector('.tab-chart-container')
      if (!dom) return
      if (dom.__echarts__) dom.__echarts__.dispose()
      const myChart = echarts.init(dom)
      const option = {
        tooltip: {
          formatter: (params) => {
            return `${
              params.seriesName
            }<br/><span style="width:10px;height:10px;display:inline-block;background-color:${
              params.color
            };border-radius:50%;margin-right:5px"></span>${
              params.name
            }<span style="font-weight:bold;margin-left:10px">${this.$tools.momenyFormat(
              params.value,
              2
            )}</span>`
          },
        },
        grid: { left: 60, top: 60, right: 40, bottom: 40 },
        xAxis: {
          type: 'category',
          data: this.chartData.map((i) => i.name),
        },
        yAxis: { type: 'value' },
        series: [
          {
            name: '设备成本',
            type: 'bar',
            data: this.chartData.map((i) => i.value),
            label: {
              show: true,
              formatter: (params) =>
                params.value === 0
                  ? ''
                  : this.$tools.momenyFormat(params.value, 2),
            },
            itemStyle: {
              color: function (params) {
                const colors = [
                  '#5470C6',
                  '#91CC75',
                  '#EE6666',
                  '#FAC858',
                  '#73C0DE',
                  '#3BA272',
                  '#FC8452',
                  '#9A60B4',
                  '#EA7CCC',
                  '#FF9F7F',
                  '#B6A2DE',
                  '#2EC7C9',
                  '#B7A2DE',
                  '#FFB980',
                  '#5AB1EF',
                ]
                return colors[params.dataIndex % colors.length]
              },
            },
          },
        ],
      }
      myChart.setOption(option)
    },
    renderPieCharts() {
      this.monthChartData.forEach((_, index) => {
        const dom = document.getElementById(`pie-chart-${index}`)
        if (dom && dom.__echarts__) {
          dom.__echarts__.dispose()
        }
      })
      this.monthChartData.forEach((month, index) => {
        const dom = document.getElementById(`pie-chart-${index}`)
        if (!dom) return
        const isAllZeroOrEmpty =
          !month.value ||
          month.value.length === 0 ||
          month.value.every((item) => !item.value || Number(item.value) === 0)
        const myChart = echarts.init(dom)
        const option = {
          title: {
            text: month.name,
            left: 'center',
            top: 20,
            textStyle: {
              fontSize: 12,
              fontWeight: 'bold',
            },
          },
          tooltip: {
            trigger: 'item',
            position: 'top',
            formatter: (params) => {
              if (!params.value || Number(params.value) === 0) return ''
              return `${params.name}: ${this.$tools.momenyFormat(
                params.value,
                2
              )} (${params.percent}%)`
            },
          },
          legend: {
            type: 'scroll',
            left: 'center',
            itemWidth: 14,
            show: false,
          },
          series: [
            {
              name: '成本分布',
              type: 'pie',
              radius: '60%',
              center: ['50%', '60%'],
              data: isAllZeroOrEmpty
                ? []
                : month.value.map((item) => ({
                    name: item.name,
                    value: item.value,
                  })),
              labelLine: {
                show: true,
                length: 1,
                length2: 1,
              },
              label: {
                show: false,
                formatter: (params) => {
                  if (!params.value || Number(params.value) === 0) return ''
                  return `${params.name}: ${this.$tools.momenyFormat(
                    params.value,
                    2
                  )} (${params.percent}%)`
                },
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
              },
            },
          ],
        }
        myChart.setOption(option)
      })
    },
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      if (this.activeName === 'CostEcharts') {
        this.chartData = []
        this.monthChartData = []
        this.getEchartsData()
      } else {
        this.handleSearch()
      }
    },
  },
  mounted() {
    this.rDate = [moment().format('YYYYMM'), moment().format('YYYYMM')]
    this.searchData.isYearMonth = this.rDate ? this.rDate[0] : ''
    this.searchData.ieYearMonth = this.rDate ? this.rDate[1] : ''
    // this.getDataList();
    this.getEchartsData()
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  height: calc(100%);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
.tab-chart-container {
  width: 100%;
  height: 300px;
  min-height: 200px;
  box-sizing: border-box;
}
.tab-chart-pieList {
  width: 100%;
  height: 200px;
  min-height: 150px;
  box-sizing: border-box;
}
.pie-charts-container {
  display: flex;
  height: 100%;
  width: 100%;
  flex-wrap: wrap;
}
.pie-chart-item {
  width: calc(100% / 12);
  min-width: 80px;
  height: 100%;
  border-right: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
}
.pie-chart-item:last-child {
  border-right: none;
}
::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: none;
}
::v-deep .el-tabs__content {
  height: calc(100% - 37px);
  .el-tab-pane {
    height: 100%;
  }
}
.chart-card {
  margin-bottom: 16px;
}
::v-deep .el-card__header {
  font-weight: bold;
}
@media (max-width: 1200px) {
  .pie-chart-item {
    width: calc(100% / 6);
  }
}
@media (max-width: 800px) {
  .pie-chart-item {
    width: calc(100% / 3);
  }
  .tab-chart-container {
    height: 220px;
  }
  .tab-chart-pieList {
    height: 120px;
  }
}
</style>
